<template>
  <w-icon-wrapper
    :height='20.779'
    :width='24'
    icon-name='work-warning-icon'
    view-box='0 0 24 20.779'
  >
    <g
      id='_37_Warnung_Icon'
      data-name='37 Warnung_Icon'
      transform='translate(0 -1.221)'
    >
      <path
        id='Pfad_55716'
        d='M12,1.221,0,22H24Zm0,4L20.535,20H3.465Z'
        data-name='Pfad 55716'
        fill='currentColor'
      />
      <path
        id='Pfad_55717'
        d='M12,9a1,1,0,0,0-1,1v5a1,1,0,0,0,2,0V10A1,1,0,0,0,12,9Z'
        data-name='Pfad 55717'
        fill='currentColor'
      />
      <circle
        id='Ellipse_1525'
        cx='1'
        cy='1'
        data-name='Ellipse 1525'
        fill='currentColor'
        r='1'
        transform='translate(11 17)'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconWarning' };
</script>
